
import React, { useState, useEffect, useRef, useMemo } from 'react';
import JoditEditor from 'jodit-react';
import './BoardUpdate.scss';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import fnc from '../mymod/commFunction';

import { useSelector, useDispatch } from 'react-redux';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setIsRefreshBoard } from '../reduxToolkit/reduxBoard';

const BoardUpdate = ({ placeholder, setIsModal_update }) => {
    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [sno, setSno] = useState('');
    const [content, setContent] = useState('');
    const [title, setTitle] = useState('');
    const [category, setCategory] = useState('');
    const [kind, setKind] = useState('');
    const [startDate, setStartDate] = useState(new Date());

    const editor = useRef(null);
    

    const selectedList = useSelector(state => state.reduxStoreBoard.selectedList);
    const boardTitle = useSelector(state => state.reduxStoreBoard.boardTitle);
    const boardKind = useSelector(state => state.reduxStoreBoard.boardKind);
    const isRefreshBoard = useSelector(state => state.reduxStoreBoard.isRefreshBoard);

    const [isUpload, setIsUpload] = useState(false);
    const [boardCode, setBoardCode] = useState(null);
    const [fileList, setFileList] = useState([]);

    const folder = 'board';


    useEffect (() => {

      setSno(selectedList.sno);
      setTitle(selectedList.title);
      setCategory(selectedList.category);
      setKind(selectedList.kind);
      setContent(selectedList.content);
      setBoardCode(selectedList.code);

    }, [selectedList]);


    const config = useMemo(
        () => ({
          readonly: false, // Jodit의 모든 옵션은 https://xdsoft.net/jodit/docs/ 에서 확인할 수 있습니다.
          placeholder: placeholder || '',
          uploader: {
              insertImageAsBase64URI: true,
              imagesExtensions: ["jpg", "png", "jpeg", "gif"],
          },
          dragAndDrop: true, // 드래그 앤 드롭을 활성화합니다.
          askBeforePasteHTML: false,
          askBeforePasteFromWord: false,
          defaultActionOnPaste: "insert_clear_html",
          colorPickerDefaultTab: "text", // 기본 탭을 텍스트로 설정
            style: {
              textAlign: 'left', // 기본 텍스트 왼쪽 정렬
          },
        }),
        [placeholder]
    );

    function onPrev() {
      setIsModal_update(false);
      dispatch(setIsRefreshBoard(!isRefreshBoard));
      
    }


    function fncUpdateBoard() {   

        if (!window.confirm("수정하시겠습니까?")) {
          return;
        }

        fnc.sendAxios('/Update_board', { sno, title, category, content, kind, date:startDate }, (response) => {       
          if (response) {

            if (fileList.length > 0) {
              setIsUpload(true);//파일저장 (상태변화로 처리함)
            }else {
              alert('완료되었습니다!!');
              onPrev();
            }

          } else {
            console.log("속성이 obj 내에 없습니다.");
          }
        });
      }
  
    //=========================================================================
    return (
      <div className='BoardUpdate'>
        <div className='frame_boardWrite'>
          
          {selectedList && <div className='box_jodit'>

                  <div className='box_title'>
                      <h2 className='title'>{boardTitle.text} 수정</h2>
                  </div>

                  <div className='formGroup'>      
                        <input
                          type="text"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                          placeholder="제목을 입력하세요"
                          className='titleInput' />

                        <div className='category_date'>
                          {/* <select
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            className='categorySelect'  >
                            <option value="">카테고리 선택</option>
                            <option value="뉴스">뉴스</option>
                            <option value="블로그">블로그</option>
                            <option value="기사">기사</option>
                          </select> */}
                          
                          <input
                            type="text"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            placeholder="카테고리를 입력하세요"
                            className='categorySelect'  />

                          <DatePicker 
                              selected={startDate} 
                              onChange={(date) => setStartDate(date)} 
                              dateFormat="yyyy-MM-dd" // 날짜 형식 지정
                          />

                        </div>

                  </div>

                  <JoditEditor
                          ref={editor}
                          value={content}
                          config={config}
                          tabIndex={1} // 텍스트 영역의 tabIndex
                          onBlur={newContent => setContent(newContent)} // 성능상의 이유로 컨텐츠를 업데이트하기 위해서는 이 옵션만 사용하는 것이 좋습니다.
                          onChange={newContent => {}} 
                  />

                  <div className='box_btnMenu'>
                      <Button className='btn h-btn-blue'  onClick={onPrev}>목록보기</Button>
                      <Button className='btn h-btn-red' onClick={fncUpdateBoard}>수정하기</Button>
                  </div>
            

            </div>

            }
      
        </div>
        </div>
    );
};

export default BoardUpdate;
